// NetSalesCalculator.js
import React, { useState } from "react";
import SharedHelmet from "../Helmet";
import RelatedLinks from "../RelatedLinks";
import { FirstAds, SecondAds,MobileUnderCalAds } from "../../Ads";
import MainCalculatorsList from "./MainCalculators";
const TITLE = "Kalkulator Penjualan Bersih - Hitung Keuntungan Bersih dengan Akurat";
const DESCRIPTION =
  "Gunakan Kalkulator Penjualan Bersih untuk menghitung pendapatan bersih dari total penjualan setelah dikurangi retur penjualan dan potongan yang diizinkan. Alat ini ideal untuk perusahaan dan pemilik bisnis untuk memantau dan menganalisis kinerja keuangan dengan akurat, serta membantu dalam menyiapkan laporan keuangan yang tepat dan meningkatkan strategi pemasaran dan penjualan.";
const KEYWORDS =
  "kalkulator penjualan bersih, hitung penjualan bersih, analisis penjualan, retur penjualan, potongan yang diizinkan, alat keuangan, laporan keuangan, manajemen penjualan";
const OG_URL = "https://do-calculate.com/calculator/id/net-sales-calculator/";
const NetSalesCalculator = () => {
  const [totalSales, setTotalSales] = useState("");
  const [salesReturns, setSalesReturns] = useState("");
  const [allowedDiscounts, setAllowedDiscounts] = useState("");
  const [netSales, setNetSales] = useState("");
  const [error, setError] = useState("");
  const handleCalculate = () => {
    try {
      const totalSalesValue = parseFloat(totalSales);
      const salesReturnsValue = parseFloat(salesReturns);
      const allowedDiscountsValue = parseFloat(allowedDiscounts);
      if (
        isNaN(totalSalesValue) ||
        isNaN(salesReturnsValue) ||
        isNaN(allowedDiscountsValue)
      ) {
        throw new Error("Harap masukkan semua nilai dengan benar.");
      }
      if (
        totalSalesValue < 0 ||
        salesReturnsValue < 0 ||
        allowedDiscountsValue < 0
      ) {
        throw new Error("Nilai yang dimasukkan tidak boleh negatif.");
      }
      const calculatedNetSales =
        totalSalesValue - salesReturnsValue - allowedDiscountsValue;
      setNetSales(calculatedNetSales.toFixed(8));
      setError("");
    } catch (err) {
      setError(err.message);
    }
  };
  return (
    <div>
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ height: "50px" }}
          >
            <h1 style={{ fontSize: "17px" }}>Kalkulator Penjualan Bersih</h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div>
                <p>
                  Kalkulator Penjualan Bersih adalah alat penting untuk membantu Anda menghitung pendapatan bersih dengan akurat dengan mengurangkan retur penjualan dan potongan yang diizinkan dari total penjualan. Dengan kalkulator ini, Anda dapat dengan mudah menentukan keuntungan bersih yang Anda hasilkan dengan mengurangi biaya yang terkait dengan penjualan dan menganalisis kinerja keuangan. Alat ini ideal untuk perusahaan dan pemilik bisnis untuk memantau kinerja keuangan, meningkatkan strategi pemasaran, dan menyajikan laporan keuangan yang akurat.
                </p>
              </div>
            </div>
            <MobileUnderCalAds/>
            <div className="row">
              <div className="col calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  <h2 style={{ fontSize: "16px" }}>Kalkulator Penjualan Bersih</h2>
                </div>
                <hr />
                <div >
                  <div>
                    <div className="form-group d-flex align-items-center">
                      <b>
                        <label className="form-label ms-2">
                          Total Penjualan
                        </label>
                      </b>
                      <input
                        type="text"
                        placeholder="Masukkan total penjualan"
                        value={totalSales}
                        onChange={(e) => setTotalSales(e.target.value)}
                        className="form-control"
                        style={{ width: "190px" }}
                      />
                    </div>
                    <br />
                    <div className="form-group d-flex align-items-center">
                      <b>
                        <label className="form-label ms-2">
                          Retur Penjualan
                        </label>
                      </b>
                      <input
                        type="text"
                        placeholder="Masukkan retur penjualan"
                        value={salesReturns}
                        onChange={(e) => setSalesReturns(e.target.value)}
                        className="form-control"
                        style={{ width: "190px" }}
                      />
                    </div>
                    <br />
                    <div className="form-group d-flex align-items-center">
                      <b>
                        <label className="form-label ms-2">
                          Potongan yang Diizinkan
                        </label>
                      </b>
                      <input
                        type="text"
                        placeholder="Masukkan potongan yang diizinkan"
                        value={allowedDiscounts}
                        onChange={(e) => setAllowedDiscounts(e.target.value)}
                        className="form-control"
                        style={{ width: "190px" }}
                      />
                    </div>
                    <br />
                    <button
                      className="btn btn-success"
                      style={{ fontSize: "20px" }}
                      onClick={handleCalculate}
                    >
                      Hitung
                    </button>
                    <div>
                      <br />
                    </div>
                    { error && (
                      <p className="p-3 mb-2 bg-warning text-white">
                        Error: {error}
                      </p>
                    )}
                    <br />
                    { netSales && (
                      <div className="p-3 mb-2 bg-success text-white">
                        <p>Penjualan Bersih:</p>
                        <p>{netSales}</p>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
            <hr /><div className="row">
              <RelatedLinks />
              <hr style={{ width: "100%" }} />
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList></MainCalculatorsList>
          <br />
        </div>
      </div>
      <div className="col-12 col-md-8">
        <div className="info-sections-container">
          <div className="info-section">
            <div className="info-section-header">
              <h3 style={{ fontSize: "16px" }}>Apa itu Penjualan Bersih?</h3>
            </div>
            <div className="info-section-body">
              <p>
                Penjualan bersih adalah nilai akhir pendapatan yang diperoleh perusahaan setelah mengurangkan semua retur dan potongan. Angka ini menunjukkan jumlah pendapatan aktual yang diperoleh perusahaan setelah mempertimbangkan penyesuaian yang diperlukan. Penjualan bersih digunakan sebagai indikator utama untuk mengukur kinerja keuangan perusahaan, dan dianggap mendasar dalam menghitung laba kotor dan menganalisis efisiensi bisnis. Misalnya, jika total penjualan adalah 5000, dan retur penjualan sebesar 300 serta potongan sebesar 200, maka penjualan bersih adalah 4500.
              </p>
            </div>
          </div>
          <div className="info-section">
            <div className="info-section-header">
              <h3 style={{ fontSize: "16px" }}>Bagaimana Cara Menghitung Penjualan Bersih?</h3>
            </div>
            <div className="info-section-body">
              <p>
                Untuk menghitung penjualan bersih, kurangkan dari total penjualan baik retur penjualan maupun potongan yang diizinkan. Langkah-langkahnya adalah sebagai berikut:
                <ul>
                  <li>Mulailah dengan total penjualan.</li>
                  <li>
                    Kurangkan nilai retur penjualan, yaitu jumlah yang dikembalikan oleh pelanggan karena retur atau kerusakan.
                  </li>
                  <li>
                    Kurangkan nilai potongan yang diizinkan, yaitu pengurangan yang diberikan kepada pelanggan.
                  </li>
                </ul>
                Misalnya, jika Anda memiliki total penjualan sebesar 1000, retur penjualan sebesar 100, dan potongan yang diizinkan sebesar 50, maka penjualan bersih akan menjadi:
                <br />
                1000 - 100 - 50 = 850.
                <br />
                Jumlah ini mewakili pendapatan aktual yang diperoleh perusahaan dari penjualan setelah penyesuaian.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default NetSalesCalculator;